export const colors = {
  sojiOrange: '#FDA800',
  black: '#000000',
  white: '#FFFFFF;',
  grey: '#FAFAFA',
  bgGrey: '#E6E6E6',
  danger: '#d72700',

  //  text colors
  greyText: '#C4C4C4',
  textDark: '#08080C',
  textDarkAlt: '#030229',
  textLight: '#D0D1D2'
};
